// @ts-nocheck
import * as React from "react";

const Youtube: React.FC = () => {
    return (
        /* Store Custom Code - Start */
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 30 30">
            <g fill="currentColor" clipPath="url(#a)">
                <path d="M15 0C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15Zm9.741 24.741A13.69 13.69 0 0 1 15 28.777a13.68 13.68 0 0 1-9.742-4.036A13.69 13.69 0 0 1 1.223 15c0-3.68 1.432-7.14 4.035-9.742A13.69 13.69 0 0 1 15 1.223c3.68 0 7.14 1.432 9.741 4.035A13.69 13.69 0 0 1 28.777 15c0 3.68-1.432 7.14-4.036 9.741Z" />
                <path d="m23.192 11.588-.05-.391a2.617 2.617 0 0 0-2.593-2.29H9.454c-1.318 0-2.429.981-2.594 2.29l-.05.391a27.42 27.42 0 0 0 0 6.824l.05.39a2.617 2.617 0 0 0 2.594 2.29h11.095c1.318 0 2.428-.98 2.594-2.29l.049-.39a27.411 27.411 0 0 0 0-6.824Zm-10.32 6.057v-5.293l5.178 2.646-5.177 2.645v.002Z" />
            </g>
            <defs>
                <clipPath id="a">
                    <path fill="#fff" d="M0 0h30v30H0z" />
                </clipPath>
            </defs>
        </svg>
        /* Store Custom Code - End */
    );
};

export default React.memo(Youtube);
